module.exports = __webpack_public_path__ + "static/media/tera.a056fb90.png";